import createLucideIcon from '../createLucideIcon';

const Bold = createLucideIcon('BoldIcon', [
  ['path', { d: 'M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z', key: 'shhoi5' }],
  ['path', { d: 'M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z', key: 'jaah4r' }],
]);

export default Bold;
